
<template>
  <Loading
    :style="{
      color,
      width: sizeComputed,
      height: sizeComputed
    }"
  />
</template>

<script>
import { Loading } from 'vant'

export default {
  components: {
    Loading
  },
  props: {
    color: {
      type: String,
      default: '#c9c9c9'
    },
    size: {
      type: Number,
      default: 32
    }
  },
  computed: {
    sizeComputed() {
      return this.size / 100 + 'rem'
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
